<template>
  <div id="translation-tool-container">
    <div class="card border-card flex-grow-1 p-sm">
      <div class="mb-md d-flex">
        <div class="flex-grow-1">
          <h1 class="card-title bold">Translation Requests</h1>
          <span>Request managed translation projects</span>
        </div>

        <div id="main-controls">
          <base-input placeholder="Search..." class="ml-sm" @input="searchTranslations" v-model="searchQuery" />

          <base-button @click="openNewTranslation">New translation</base-button>
        </div>
      </div>

      <div class="mb-lg">
        <el-collapse>
          <el-collapse-item title="Show Filters">
            <TranslationFilters :availableLanguages="possibleLanguages" :availableStatuses="possibleStatuses"
              @change="getTranslationsByFilters" />
          </el-collapse-item>
        </el-collapse>
      </div>

      <div>
        <!-- <div class="d-flex align-items-center justify-content-end">
          <div class="card border-card" style="width: auto">
            <div class="card-body">
              <span>{{
                new Date().toLocaleDateString("default", {
                  month: "long",
                  year: "numeric",
                })
              }}
                -
                <strong>{{ totalTranslatedWordsCount }} translated words</strong></span>
            </div>
          </div>
        </div> -->

        <el-table :data="translations" thead-classes="text-primary">
          <el-table-column label="Title" prop="title">
            <template #default="{ row }">
              <span class="bold" style="cursor: pointer" @click="openSidebar(row)">{{
                row.title
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Languages" prop="languages">
            <template #default="{ row }">
              <span class="text-break text-capitalize">{{
                formatLanguagesEnglish(row.languages)
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Requester" prop="requester">
            <template #default="{ row }">
              {{ row.client.email }}
            </template>
          </el-table-column>

          <el-table-column label="Status" prop="status">
            <template #default="{ row }">
              <base-chip :class="{
                'status-chip-to-do': row.status == 'TODO',
                'status-chip-in-progress': row.status == 'IN_PROGRESS',
                'status-chip-done': row.status == 'DONE',
              }" class="text-wrap">
                <i class="fa-solid fa-comment" v-if="row.notes.by_assignee"></i>
                {{ formatStatus(row.status) }}
              </base-chip>
            </template>
          </el-table-column>

          <el-table-column label="Created on" prop="timestamps.createdAt">
            <template #default="{ row }">
              {{ formatDate(row.timestamps.createdAt) }}
            </template>
          </el-table-column>

          <el-table-column label="Deadline" prop="timestamps.deadline">
            <template #default="{ row }">
              {{ row.timestamps.deadline ? formatDate(row.timestamps.deadline) : "None" }}
            </template>
          </el-table-column>

          <el-table-column label="Actions" class="d-flex justify-content-end">
            <template #default="{ row }">
              <!-- <base-dropdown
                                title-classes="dropdown-icon-button"
                                menu-classes="dropdown-navbar dropdown__container_menu"
                            >
                               <template #title>
                                    <i class="fas fa-ellipsis-v"></i>
                                </template>

  <button class="dropdown-link-button" @click="downloadTranslationFiles(row)">Download</button>
  <button class="dropdown-link-button" @click="deleteTranslation(row)">Delete</button>
  </base-dropdown> -->

              <div class="d-flex align-items-center justify-content-start" style="gap: 3px">
                <base-button :disabled="row.status === 'IN_PROGRESS'" @click="downloadTranslationFiles(row)"
                  class="px-2 py-1">
                  <i class="fa-solid fa-download"></i>
                </base-button>

                <base-button :disabled="row.status === 'IN_PROGRESS'" @click="deleteTranslation(row)"
                  class="px-2 py-1 delete_btn">
                  <i class="fa-solid fa-trash"></i>
                </base-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="card border-card p-sm" id="translation-tool-sidebar" v-if="openNewTranslationForm">
      <div class="d-flex">
        <h2 class="card-title flex-grow-1">New translation</h2>

        <button type="button" class="close" @click="openNewTranslationForm = false" data-dismiss="modal"
          aria-label="Close">
          <i class="fa-solid fa-circle-xmark"></i>
        </button>
      </div>

      <div>
        <TranslationRequestForm :possibleLanguages="possibleLanguages" @submit="onNewTranslationRequestSubmit" />
      </div>
    </div>
    <div class="card border-card p-sm" id="translation-tool-sidebar" v-if="selectedTranslation"
      :key="`sidebar-${selectedTranslation.id}`">
      <div class="d-flex">
        <h2 class="card-title flex-grow-1">{{ selectedTranslation?.title }}</h2>

        <button type="button" class="close" @click="selectedTranslation = null" data-dismiss="modal" aria-label="Close">
          <i class="fa-solid fa-circle-xmark"></i>
        </button>
      </div>

      <div v-if="selectedTranslation.status === 'DONE'" id="translation-tool-step-selection" class="mt-sm">
        <!-- <button @click="selectedStep = 'summary'" :class="{ 'selected': selectedStep == 'summary' }">
                    Summary
                </button>

                <button @click="selectedStep = 'end-task'" :class="{ 'selected': selectedStep == 'end-task' }">
                    End task
                </button> -->

        <div class="client-btns">
          <base-button v-if="!selectedTranslation?.feedbackSent" @click="openFeedbackModal" type="outlined"
            class="summary-btn fs-14">
            Send Feedback
          </base-button>

          <base-button @click="() => downloadTranslationFiles()" class="summary-btn">
            Download
          </base-button>
        </div>

        <base-textarea v-model="selectedTranslation.notes.byAssignee" label="Translator notes"
          :setStyle="{ minHeight: '85px' }" disabled class="translator-notes" />
      </div>

      <div>
        <hr class="my-sm" />

        <h3 class="card-title">Summary</h3>

        <TranslationSummary v-if="selectedTranslation" :translation="selectedTranslation" @close="closeSidebar"
          disabled />
      </div>

      <el-dialog :visible.sync="feedbackFormVisible" width="560px">
        <h4 class="sendTitle">Send feedback</h4>
        <h2 class="requestTitle">
          {{ selectedTranslation?.title }}
        </h2>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(sendFeedback(selectedTranslation.id))">
            <div class="FeedbackModal">
              <p v-if="feedbackEditing" class="mb-4 text-success">
                Your feedback has been submitted. You can edit it and resubmit if needed.
              </p>
              <p v-else class="mb-4">
                Send your feedback on the received translation, add comments, and attach
                documents if needed for clarifications or corrections.
              </p>
              <ValidationProvider rules="required">
                <base-textarea v-model="feedback.content" label="Your feedback" type="text"
                  placeholder="Type here your message" :setStyle="{ minHeight: '135px' }">
                </base-textarea>
              </ValidationProvider>
              <FileUpload multiple :fileType="'.pdf,.xls,.xlsx,.doc,.docx,.txt,.csv'" compact class="attachment" @deleteFile="deleteFile"
                @addFile="onFileChange" />
              <div v-if="selectedTranslation.feedback">
                <TranslationFileView v-for="feedbackFile in selectedTranslation.feedback.files"
                  :translationFile="feedbackFile" :key="feedbackFile.url" />
              </div>
              <div class="row mt-2 align-items-center">
                <div class="col-6 pr-2">
                  <base-button @click="feedbackFormVisible = false" type="primary"
                    class="btn-fill btn_add_link px-3 mt-0 w-100">
                    Cancel
                  </base-button>
                </div>
                <div class="col-6 pl-2">
                  <base-button native-type="submit" type="primary" :disabled="!feedback.content"
                    class="btn-fill btn_submit_form px-3 mt-2 w-100 feedbackBtn">
                    {{ feedbackEditing ? "Edit" : $t("seats.send") }}
                  </base-button>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </el-dialog>
    </div>

    <!-- <TranslationSummary v-if="selectedTranslation" :translation="selectedTranslation" @close="closeSidebar" /> -->
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DatePicker,
  Message,
  Collapse,
  CollapseItem,
} from "element-ui";
import { BaseButton, BaseDropdown } from "@/components";
import BaseChip from "../../../components/UI/BaseChip.vue";
import TranslationRequestForm from "../../TranslationManager/Components/TranslationRequestForm.vue";
import TranslationFilters from "../../TranslationManager/Components/TranslationFilters.vue";
import TranslationSummary from "../../TranslationManager/Components/TranslationSummary.vue";
import TranslationFileView from "../../TranslationManager/Components/TranslationFileView.vue";
import { BaseInput, BaseTextarea, FileUpload } from "@/components";

import downloadTranslationFilesHelper from "../../TranslationManager/Helpers/downloadTranslationFiles";
import { formatLanguagesEnglish, formatStatus, formatDate } from "../../TranslationManager/Helpers/formatters";
import Translation from "../../TranslationManager/Entities/Translation";
import { apiHandler } from "@/util/errorHandling";
import debounce from "lodash/debounce";
import { Dialog, Select, Option } from "element-ui";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseChip,
    [DatePicker.name]: DatePicker,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    BaseButton,
    // BaseDropdown,
    TranslationFilters,
    TranslationRequestForm,
    TranslationSummary,
    BaseInput,
    BaseTextarea,
    TranslationFileView,
    FileUpload,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      /** @type Translation[] */
      translations: [],
      openNewTranslationForm: false,
      assigneeNotes: null,
      selectedTranslation: null,
      // This variable is not used, however if we don't put SOMETHING as a v-model on the
      // base-input component it won't work, so this is what this is used for
      searchQuery: null,
      possibleLanguages: [],
      possibleStatuses: [],
      feedbackFormVisible: false,
      totalTranslatedWordsCount: 0,
      feedback: null,
      feedbackEditing: false,
    };
  },
  methods: {
    onFileChange(file) {
      this.feedback.files = file;
    },
    deleteFile() {
      this.feedback.files = [];
    },
    openFeedbackModal() {
      if (this.selectedTranslation) {
        if (
          this.selectedTranslation.feedback &&
          this.selectedTranslation.feedback.content != ""
        ) {
          this.feedbackEditing = true;
          this.feedback = {
            content: this.selectedTranslation.feedback.content,
            files: this.selectedTranslation.feedback.files,
          };
        } else {
          this.feedbackEditing = false;
          this.feedback = {
            content: "",
            files: [],
          };
        }
        this.feedbackFormVisible = true;
      }
    },
    openSidebar(translation) {
      if (this.selectedTranslation?.id === translation.id) {
        this.selectedTranslation = null;
      } else {
        this.openNewTranslationForm = false;
        this.selectedTranslation = translation;
      }
    },

    closeSidebar() {
      this.selectedTranslation = null;
    },

    openNewTranslation() {
      this.selectedTranslation = null;
      this.openNewTranslationForm = true;
    },
    workspaceId() {
      return this.$store.getters.selectedWorkspace.id;
    },
    async getTranslations() {
      console.log("translations");
      let response;

      await apiHandler(async () => {
        response = await this.$axios.get(
          "tools/translation-manager/client/get-translations"
        );
      });

      this.translations = response.data.data?.map((t) => new Translation(t)) ?? [];
    },
    async getTranslationsByFilters(filters) {
      let response;

      await apiHandler(async () => {
        response = await this.$axios.get(
          "tools/translation-manager/client/get-translations",
          {
            params: {
              title: filters.title,
              translated_words_count: filters.translatedWordsCount ?? null,
              workspace_id: this.workspaceId(),
              email: filters.email ?? null,
              created_at: filters.createdAt ? formatDate(filters.createdAt) : null,
              deadline: filters.deadline ? formatDate(filters.deadline) : null,
              languages: filters.languages ?? null,
              statuses: filters.statuses ?? null,
            },
          }
        );
      });

      this.translations = response.data.data?.map((t) => new Translation(t)) ?? [];
    },
    async getSingleTranslation(translationId) {
      let response;

      await apiHandler(async () => {
        response = await this.$axios.get(
          "tools/translation-manager/client/get-translation/" + translationId
        );
      });

      return new Translation(response.data.data);
    },
    searchTranslations: debounce(async function (query) {
      await this.getTranslationsByFilters({
        title: query,
      });
    }, 500),
    /** @param {Translation} translation */
    async downloadTranslationFiles(translation) {
      console.log("translation", typeof translation);
      console.log(translation);
      if (translation) {
        downloadTranslationFilesHelper(translation);
      } else {
        console.log("no trans");
        downloadTranslationFilesHelper(this.selectedTranslation);
      }
    },
    async onNewTranslationRequestSubmit(translation) {
      await this.reset();
    },
    async deleteTranslation(translation) {
      await apiHandler(async () => {
        await this.$axios.delete("tools/translation-manager/client/delete-translation", {
          params: {
            translation_id: translation.id,
          },
        });
        await this.reset();
      });
    },
    async getSetupInformation() {
      await apiHandler(async () => {
        const response = await this.$axios.get(
          "tools/translation-manager/client/get-setup-information"
        );

        const options = response.data.options;
        this.possibleLanguages = options.available_languages;
        this.possibleStatuses = options.available_statuses;
        this.$forceUpdate();
      });
    },

    async getStatistics() {
      await apiHandler(async () => {
        const response = await this.$axios.get(
          "tools/translation-manager/client/get-statistics"
        );

        this.totalTranslatedWordsCount = response.data.total_translated_words_count;
        this.$forceUpdate();
      });
    },

    async reset() {
      this.openNewTranslationForm = false;

      this.feedback = {
        content: "",
        files: [],
      };

      await this.getTranslationsByFilters({
        title: null,
      });
      this.$forceUpdate();
    },
    async sendFeedback(translationId) {
      // if (this.feedbackSent[translationId] && this.feedback[translationId] === this.initialMessages[translationId]) {
      //   Message.info("No changes detected in feedback.");
      //   return;
      // }

      const formData = new FormData();
      formData.append("translation_id", translationId);
      formData.append("content", this.feedback.content);
      if (this.feedback.files.length > 0) {
        formData.append("files[]", this.feedback.files[0]);
      }

      try {
        await this.$axios.post(
          "tools/translation-manager/client/send-feedback",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        await this.reset();
        Message.success("Feedback sent!");
        this.feedbackFormVisible = false;
      } catch (error) {
        Message.error(error);
      }
    },
    formatDate,
    formatStatus,
    formatLanguagesEnglish,
  },
  mounted() {
    this.getSetupInformation();
    this.getStatistics();
    this.reset();
  },
};
</script>

<style scoped lang="scss">
#translation-tool-container {
  display: flex;
  gap: 22px;
  align-items: flex-start;

  #main-controls {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--gap, 10px);

    >* {
      margin: 0 !important;
    }
  }
}

#translation-tool-sidebar {
  max-width: 400px;
}

.status-chip {
  &-to-do {
    background-color: #999999 !important;
  }

  &-in-progress {
    background-color: #ff9d00 !important;
  }

  &-done {
    background-color: #00bc7e !important;
  }
}

.client-btns {
  width: 100%;
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.summary-btn {
  width: 200px;
}

.translator-notes {
  height: 90px;
}

.FeedbackModalContainer {
  max-width: 560px;
}

.FeedbackModal {
  width: 500px;
  padding: 24px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex-shrink: 0;
}

.feedbackBtn {
  margin-top: 14px !important;
}

.sendTitle {
  color: var(--blu-004583, #004583);
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 5px;
}

.requestTitle {
  color: var(--blu-004583, #004583);
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 0px;
}

.delete_btn {
  background-color: #F2F4F6 !important;
  color: #007BFF;
  border: 1px solid;
  border-color: #007BFF !important;
  background: transparent;
  font-size: 0.9375rem;
  overflow: hidden;
  position: relative;
  line-height: normal;
}
</style>
